import useProject from '~/hooks/useProject';
import { getQuarterNotesPerBar } from '~/lib/exporters/utils';
import webViewTransformer from '~/lib/transformers/webView';
import { Bar } from './Bar';
import { SingleNote } from './SingleNote';
import Track from './Track';
import TrackMeta from './TrackMeta';
import SceneName from './SceneName';

function Arrangements({ projectId }: { projectId: string }) {
  const { data } = useProject(projectId);

  if (!data) {
    return null;
  }

  const transformedData = webViewTransformer(data);
  const barLength =
    getQuarterNotesPerBar(
      transformedData.scenesSettings.timeSignature.numerator,
      transformedData.scenesSettings.timeSignature.denominator,
    ) * 4;

  return (
    <div className="flex gap-4 h-full">
      {transformedData.scenes.map((sceneData) => (
        <div className="flex flex-col gap-2">
          <SceneName projectId={projectId} defaultName={sceneData.name} />
          {sceneData.patterns.map((pattern) => (
            <div className="flex gap-2">
              <TrackMeta pattern={pattern} />
              <div
                style={{ width: sceneData.maxBars * barLength * 24 }}
                className="overflow-hidden"
              >
                <Track>
                  {pattern.bars > 0 && sceneData.maxBars % pattern.bars === 0
                    ? [...Array(sceneData.maxBars / pattern.bars).keys()].map((index) => (
                        <Bar lengthInBars={pattern.bars} barLength={barLength} index={index}>
                          {pattern.notes.map((note) => (
                            <SingleNote key={`${note.note}-${note.position}`} note={note} />
                          ))}
                        </Bar>
                      ))
                    : null}
                  {pattern.bars > 0 && sceneData.maxBars % pattern.bars !== 0 ? (
                    <Bar lengthInBars={pattern.bars} barLength={barLength} index={0}>
                      {pattern.notes.map((note) => (
                        <SingleNote key={`${note.note}-${note.position}`} note={note} />
                      ))}
                    </Bar>
                  ) : null}
                </Track>
              </div>
            </div>
          ))}
        </div>
      ))}

      {transformedData.scenes.length === 0 && (
        <div className="w-full h-full flex items-center justify-center">No arrangements found</div>
      )}
    </div>
  );
}

export default Arrangements;
